import axios from 'axios'
import qs from 'qs';
import {
  Loading,
  Message
} from 'element-ui'

const protocol = window.location.protocol;

export const _DOMAIN = protocol + '//wenjuan.58.com';
const baseURL = process.env.NODE_ENV === "development" ? '' : _DOMAIN;

// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;
axios.defaults.baseURL = baseURL;
const disableLoadingUrls = ['/bsp/search', '/survey/cooperation/op', 'survey/cooperation/list']
let loadingInstance = null;
const loadingOptions = {
  lock: true,
  text: '拼命加载中',
};

// 请求拦截器
axios.interceptors.request.use(function (config) {
  let url = config.url;
  if (!(url.indexOf(disableLoadingUrls[0]) > -1 || url.indexOf(disableLoadingUrls[1]) > -1 || url.indexOf(disableLoadingUrls[2]) > -1)) {
    loadingInstance = Loading.service(loadingOptions);
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
// 响应拦截器
axios.interceptors.response.use(
  response => {
    loadingInstance.close();
    if (response.status === 200) {
      if (response.data.code === -101) {
        window.location.href = `${window.location.origin}/#/login`;
      } else {
        return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    loadingInstance.close();
    if (error.response.status) {
      console.log(error.response)
      if (error.response.status == 302) {
        window.location.href = response.headers.location;
      }
      return Promise.reject(error.response);
    }
  }
);


let get = function (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
        Message({
          type: "error",
          message: err.data
        });
      })
  });
}

let post = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(data))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        Message({
          type: "error",
          message: err.data
        });
        reject(err.data)
      })
  });
}


export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/http.js